import { createContext } from 'react';
import type { AuthContextValue } from './authTypes';

/**
 * Auth context. Undefined by default so `useAuth` can throw a clear error when a
 * consumer is rendered outside {@link AuthProvider}, catching wiring mistakes.
 */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
